import { Popover } from "common/styleguide/Popover";
import { commonVerbs, Msg } from "lib/localization";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import styles from "./LocaleSwitcherBump.scss";

export const LocaleSwitcherBump = ({ target, currentUser, onDismiss, intl }) => (
  <Popover noPadding intl={intl} placement="bottom" target={target} maxWidth="225px" onRequestClose={onDismiss}>
    <div className={styles.LocaleSwitcherBump}>
      <div className={styles.header}>
        <T id="LocaleSwitcherBump.header" defaultMessage="Change Your Language" />
      </div>
      <div className={styles.body}>
        <T id="LocaleSwitcherBump.body" defaultMessage="Click here to change your language preference at any time" />
      </div>
      <a onClick={onDismiss} className={styles.dismiss}>
        <Msg capitalized m={commonVerbs.dismiss} />
      </a>
    </div>
  </Popover>
);
